(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-result-missing-data', {
            parent: 'entity',
            url: '/patient-result-missing-data?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientResultMissingData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data.html',
                    controller: 'PatientResultMissingDataController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('patient-result-missing-data-detail', {
            parent: 'entity',
            url: '/patient-result-missing-data/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientResultMissingData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data-detail.html',
                    controller: 'PatientResultMissingDataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PatientResultMissingData', function($stateParams, PatientResultMissingData) {
                    return PatientResultMissingData.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'patient-result-missing-data',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('patient-result-missing-data-detail.edit', {
            parent: 'patient-result-missing-data-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data-dialog.html',
                    controller: 'PatientResultMissingDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientResultMissingData', function(PatientResultMissingData) {
                            return PatientResultMissingData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-result-missing-data.new', {
            parent: 'patient-result-missing-data',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data-dialog.html',
                    controller: 'PatientResultMissingDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                result: null,
                                barcode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient-result-missing-data', null, { reload: 'patient-result-missing-data' });
                }, function() {
                    $state.go('patient-result-missing-data');
                });
            }]
        })
        .state('patient-result-missing-data.edit', {
            parent: 'patient-result-missing-data',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data-dialog.html',
                    controller: 'PatientResultMissingDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientResultMissingData', function(PatientResultMissingData) {
                            return PatientResultMissingData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-result-missing-data', null, { reload: 'patient-result-missing-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-result-missing-data.delete', {
            parent: 'patient-result-missing-data',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data-delete-dialog.html',
                    controller: 'PatientResultMissingDataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatientResultMissingData', function(PatientResultMissingData) {
                            return PatientResultMissingData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-result-missing-data', null, { reload: 'patient-result-missing-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
